import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "form", "input"]

  connect() {
    this.value = this.element.dataset.inlineEditValue || ""
    this.url = this.element.dataset.inlineEditUrl
  }

  edit(event) {
    event.preventDefault()
    this.inputTarget.value = this.value
    this.displayTarget.hidden = true
    this.formTarget.classList.remove("d-none")
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  cancel(event) {
    if (event) event.preventDefault()
    this.formTarget.classList.add("d-none")
    this.displayTarget.hidden = false
  }

  async save(event) {
    event.preventDefault()
    const body = new FormData()
    body.append("value", this.inputTarget.value)

    const headers = { "X-CSRF-Token": this.csrfToken }
    if (window.Turbo) headers.Accept = "text/vnd.turbo-stream.html, application/json"

    const response = await fetch(this.url, { method: "PATCH", headers, body })
    const contentType = response.headers.get("content-type") || ""

    if (window.Turbo && contentType.includes("turbo-stream")) {
      window.Turbo.renderStreamMessage(await response.text())
    } else {
      const data = await response.json()
      this.value = data.booking.comment || ""
      this.displayTarget.textContent = this.value || "add a comment"
      this.cancel()
    }
  }

  get csrfToken() {
    const meta = document.querySelector("meta[name='csrf-token']")
    return meta && meta.content
  }
}
